import { CompanyPosition } from 'api/company'
import { useMemo } from 'react'

type CurrentRequirement = CompanyPosition['requirements2'][number] & {
  isMustHave: boolean
}

export function useCurrentRequirements(position?: CompanyPosition | null) {
  return useMemo(() => {
    if (!position) return []
    const allRequirements = position.requirements2
    const mustHaveIds = position.mustHaveRequirements?.map((r) =>
      r.id?.toString()
    )
    return allRequirements?.map((r) => {
      return {
        ...r,
        isMustHave: mustHaveIds?.includes(r.id?.toString()) ?? false,
      } as CurrentRequirement
    })
  }, [position])
}
